const normalizeSteps = (data) => {
    const rawSteps = Array.isArray(data?.steps) ? data.steps : []
    const steps = rawSteps.sort(
        (a, b) => (a.stepNumber || 0) - (b.stepNumber || 0)
    )

    const totalSteps = Number(data?.totalSteps || steps.length || 0)

    return {
        ...data,
        steps,
        totalSteps,
    }
}

export const fetchHexSteps = async (apiProjectId, isPreview, screenId) => {
    if (!apiProjectId) {
        throw new Error('apiProjectId is required to fetch hex steps')
    }

    const BACKEND_URL =
        process.env.REACT_APP_API_BASE || ''
    const basePath = isPreview
        ? `${BACKEND_URL}/api/staging/hex/${apiProjectId}`
        : `${BACKEND_URL}/api/hex/${apiProjectId}`
    const endpoint = screenId ? `${basePath}/${screenId}` : basePath

    const response = isPreview ? await fetch(endpoint, { credentials: 'include' }) : await fetch(endpoint)

    if (!response.ok) {
        throw new Error(`Hex steps request failed: ${response.status}`)
    }

    const data = await response.json()
    console.log('Normalized data:', normalizeSteps(data))
    return normalizeSteps(data)
}
